import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-whatsapp-button',
  templateUrl: './whatsapp-button.component.html',
  styleUrls: ['./whatsapp-button.component.css']
})
export class WhatsappButtonComponent {
  @Input() buttonText!: string;
  openWhatsApp(): void {
    const phoneNumber = '201018519312';
    const url = `https://wa.me/${phoneNumber}`;
    window.open(url, '_blank');
  }
}
